import { blurOnSearchActions } from '../../services';

export const blurOnSearchDispatcher = dispatch => ( {
  showBlurOnSearch: () => dispatch( { type: blurOnSearchActions.SHOW} ),
  hideBlurOnSearch: () => dispatch({ type:blurOnSearchActions.HIDE})
} );